import * as types from '../actions/actionTypes';
import initialState from './initialState';

export default function countries(state = initialState.countries, action) {
  switch (action.type) {
    case types.SET_COUNTRIES:
      return action.countries;
    default:
      return state;
  }
}
